export default __webpack_public_path__ + "static/media/sendEnable.52080dc5.svg";